export default __webpack_public_path__ + "static/media/problema-02.93f912f7.webp";